module.exports = __webpack_public_path__ + "static/media/16UNODC6.8d0e31ca.jpg";